module.exports = __webpack_public_path__ + "media/packs/images/flags/BH-e1bb6c5e2a3713c0b8c7c8063634208b.png";